import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  header: { textAlign: 'center', position: 'relative', marginBottom: '4rem', marginTop: '5.2rem' },
  title: {
    font: { size: '3.4rem', lineHeight: '4rem', weight: 700 },
    color: colors.neutral[900],
    margin: '0rem 0rem 1.6rem 0rem',
  },
  caption: {
    margin: '0 auto 1.2rem',
    font: { size: '1.8rem', lineHeight: '2.8rem' },
    letterSpacing: '0.02rem',
    maxWidth: '70%',
  },
  backButton: {
    position: 'absolute',
    left: 0,
    top: '1rem',
    paddingLeft: 0,
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
